<template>
  <page-view
    class="subpage video"
    backText="Back to Videos"
    :backLink="backLink"
    :title="video ? video.metadata.title : ''"
    :id="video ? video.id : ''"
  >
    <template v-slot:id>
      <template v-if="video">
        <id :id="video.id" />
      </template>
    </template>
    <template v-slot:header-right>
      <template v-if="video">
        <dots class="border left m-r-2">
          <ul>
            <li @click="deleteVideo">
              <i class="icon-close-medium" />
                Delete video
            </li>
            <a :href="`https://${fqdn}.streamify.io/play/broadcast/${id}`" v-if="featuresEnabled.includes('ppv')" target="_blank">
              <i class="icon-eye" />
              View on Play
            </a>
          </ul>
        </dots>
      </template>
    </template>
    <template v-slot:tabs v-if="video">
      <page-tab title="Video" :active="currentTab === ''" @click.native="handleLink($event, `/video/${video.id}`)" :link="`/video/${video.id}`">Video</page-tab>
      <page-tab title="Settings" :active="currentTab === 'settings'" @click.native="handleLink($event, `/video/${video.id}/settings`)" :link="`/video/${video.id}/settings`">Settings</page-tab>
      <page-tab title="Commerce" :active="currentTab === 'commerce'" @click.native="handleLink($event, `/video/${video.id}/commerce`)" :link="`/video/${video.id}/commerce`" v-if="video.protected.pay_per_view.enabled">Commerce</page-tab>
      <page-tab title="Statistics" :active="currentTab === 'statistics'" @click.native="handleLink($event, `/video/${video.id}/statistics`)" :link="`/video/${video.id}/statistics`">Statistics</page-tab>
    </template>
    <template v-if="video">
      <router-view />
    </template>
  </page-view>
</template>

<script>

import Dots from '@/components/Dots.vue';

export default {
  components: {
    Dots,
  },
  props: {
    id: {
      type: String,
      default: null,
      required: true,
    },
  },
  computed: {
    /**
     * Return the current tab
     * @return {String}
     */
    currentTab() {
      const tab = this.$route.path.split('/').pop();
      return tab === this.video.id ? '' : tab;
    },
  },
  methods: {
    /**
     * Get the video with ID
     * @returns {Void}
     */
    async getVideo() {
      this.video = await this.$store.dispatch('Video/getVideo', this.id);
    },
    async deleteVideo() {
      const willDelete = await swal({
        title: this.$t('errors.are_you_sure'), text: this.$t('video.once_removed'), icon: 'warning', buttons: true, dangerMode: true,
      });

      if (!willDelete) {
        return;
      }

      const doesIt = await this.$store.dispatch('Video/delete', this.id);

      if (!doesIt) {
        swal({ title: this.$t('errors.error_occured'), text: this.$t('video.removed_error'), icon: 'error' });
        return;
      }

      this.$router.push(this.backLink);
    },
  },
  data() {
    return {
      backLink: '/videos',
      video: null,
      state: 'loading',
    };
  },
  async mounted() {
    await this.getVideo();

    const lastRoute = this.$store.getters['Theme/lastRoute'];
    if (lastRoute && lastRoute.path.includes('videos')) {
      this.backLink = lastRoute.fullPath;
    }

    this.state = '';
  },
};
</script>
